import type { LeaderboardEntry } from '../score/Leaderboard';
import { formatTime } from '../utils/format';
import { el, setText } from './dom';
import { MenuScreen } from './MenuScreen';

/** Details use the stored run's splits, including checkpoints from older builds. */
export class LeaderboardSplitsScreen extends MenuScreen {
  private readonly summary = el('p', 'split-details__summary');
  private readonly rows = el('tbody');
  private readonly empty = el('p', 'menu-card__sub', 'Tälle tulokselle ei ole tallennettu checkpoint-aikoja.');
  private visible = false;
  private returnFocus: HTMLElement | null = null;

  constructor(onClose: () => void) {
    super('VÄLIAJAT', 'Kaikki checkpoint-ajat', onClose, 'TAKAISIN');
    this.root.classList.add('split-details');
    this.root.setAttribute('role', 'dialog');
    this.root.setAttribute('aria-modal', 'true');
    this.root.setAttribute('aria-label', 'Tuloksen checkpoint-ajat');
    const table = el('table', 'split-details__table');
    const head = el('thead');
    const row = el('tr');
    for (const label of ['Checkpoint', 'Aika alusta', 'Osuusaika']) {
      const cell = el('th', undefined, label);
      cell.scope = 'col';
      row.append(cell);
    }
    head.append(row);
    table.append(head, this.rows);
    this.body.append(this.summary, table, this.empty);
    this.root.addEventListener('keydown', (event) => {
      if (event.key === 'Tab') {
        event.preventDefault();
        this.root.querySelector('button')?.focus();
      }
    });
  }

  show(entry: LeaderboardEntry): void {
    this.returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    setText(this.summary, `${entry.rank}. ${entry.name} · ${formatTime(entry.timeMs)}`);
    this.rows.replaceChildren();
    let previous = 0;
    for (const split of entry.splits) {
      const row = el('tr');
      const label = el('th', undefined, split.label);
      label.scope = 'row';
      row.append(label, el('td', undefined, formatTime(split.timeMs)),
        el('td', undefined, formatTime(split.timeMs - previous)));
      this.rows.append(row);
      previous = split.timeMs;
    }
    this.empty.hidden = entry.splits.length > 0;
  }

  override setVisible(visible: boolean): void {
    super.setVisible(visible);
    if (visible === this.visible) return;
    this.visible = visible;
    if (visible) this.root.querySelector('button')?.focus();
    else {
      if (this.root.contains(document.activeElement)) (document.activeElement as HTMLElement).blur();
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
      this.returnFocus = null;
    }
  }
}
